/* Imperial units — models think in feet/inches, storage stays metric (cm).
   fmt* for display, *ToCm for form saves. */

export const cmToInches = (cm) => cm / 2.54;

export function fmtHeight(cm) {
  if (!cm) return null;
  const total = cmToInches(cm);
  const ft = Math.floor(total / 12);
  let inch = Math.round(total - ft * 12);
  if (inch === 12) return `${ft + 1}'0"`;
  return `${ft}'${inch}"`;
}

export function fmtMeasure(cm) {
  if (!cm) return null;
  return `${Math.round(cmToInches(cm))}"`;
}

export function splitHeight(cm) {
  if (!cm) return { ft: "", inch: "" };
  const total = cmToInches(cm);
  return { ft: Math.floor(total / 12), inch: Math.round(total % 12) };
}

export function heightToCm(ft, inch) {
  const f = parseInt(ft, 10) || 0;
  const i = parseInt(inch, 10) || 0;
  return f || i ? Math.round((f * 12 + i) * 2.54) : null;
}

export function inchesToCm(inches) {
  const v = parseFloat(inches);
  return Number.isFinite(v) && v > 0 ? Math.round(v * 2.54) : null;
}
